// Converts base64 string OR URL to usable image src
export function getImage(image: string | null | undefined): string | undefined {
  if (!image) return undefined;

  // If already full URL (object store, CDN, etc.)
  if (image.startsWith("http://") || image.startsWith("https://")) {
    return image;
  }

  // If already data URL
  if (image.startsWith("data:image")) {
    return image;
  }

  // Otherwise assume base64 string
  try {
    const decodedData = atob(image);

    const byteArr = new Uint8Array(decodedData.length);

    for (let i = 0; i < decodedData.length; i++) {
      byteArr[i] = decodedData.charCodeAt(i);
    }

    const blob = new Blob([byteArr], { type: "image/jpeg" });

    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Invalid base64 image string:", error);
    return undefined;
  }
}
